module.exports = __webpack_public_path__ + "rw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/rw.svg
// module id = 785
// module chunks = 0